export interface TierStyle {
  className: string;
  icon: string;
}

const STYLES: Record<string, TierStyle> = {
  Neighbor: {
    className:
      "border-emerald-300/40 bg-emerald-50 text-emerald-700 dark:border-emerald-600/30 dark:bg-emerald-950/40 dark:text-emerald-300",
    icon: "✦",
  },
  Connector: {
    className:
      "border-sky-300/40 bg-sky-50 text-sky-700 dark:border-sky-600/30 dark:bg-sky-950/40 dark:text-sky-300",
    icon: "✦",
  },
  "Community Builder": {
    className:
      "border-violet-300/40 bg-violet-50 text-violet-700 dark:border-violet-600/30 dark:bg-violet-950/40 dark:text-violet-300",
    icon: "✦",
  },
  "Local Hero": {
    className:
      "border-amber-300/40 bg-amber-50 text-amber-700 dark:border-amber-600/30 dark:bg-amber-950/40 dark:text-amber-400",
    icon: "★",
  },
  "Founding Champion": {
    className:
      "border-rose-300/50 bg-gradient-to-r from-amber-50 via-rose-50 to-violet-50 text-rose-700 dark:border-rose-600/40 dark:from-amber-950/40 dark:via-rose-950/40 dark:to-violet-950/40 dark:text-rose-300",
    icon: "♛",
  },
  "Founding Maker": {
    className:
      "border-amber-400/50 bg-gradient-to-r from-amber-50 to-orange-50 text-amber-800 dark:border-amber-500/40 dark:from-amber-950/40 dark:to-orange-950/40 dark:text-amber-300",
    icon: "✺",
  },
};

export function tierStyle(name: string | null | undefined): TierStyle {
  if (!name) return STYLES.Neighbor;
  return STYLES[name] ?? STYLES.Neighbor;
}
